// test2262
(2262 && 0);
